import { render, staticRenderFns } from "./ManageImages.vue?vue&type=template&id=a274cec0"
import script from "./ManageImages.vue?vue&type=script&lang=js"
export * from "./ManageImages.vue?vue&type=script&lang=js"
import style0 from "./ManageImages.vue?vue&type=style&index=0&id=a274cec0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports